<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="margin-right-small">
    <input matInput autocomplete="off" formControlName="DateFrom" [matDatepicker]="pickerFrom" placeholder="Fecha desde" required>
    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
    <mat-datepicker #pickerFrom></mat-datepicker>
    <mat-error *ngIf="f.DateFrom.errors && f.DateFrom.errors.required">
      Ingrese la fecha desde
    </mat-error>
  </mat-form-field>
  <mat-form-field class="margin-right-small">
    <input matInput autocomplete="off" formControlName="DateTo" [matDatepicker]="pickerTo" placeholder="Fecha hasta" required>
    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
    <mat-datepicker #pickerTo></mat-datepicker>
    <mat-error *ngIf="f.DateTo.errors && f.DateTo.errors.required">
      Ingrese la fecha hasta
    </mat-error>
  </mat-form-field>

  <mat-form-field class="full-width">
    <input type="text" #physician matInput placeholder="Médico" formControlName="Physician" [matAutocomplete]="autPhysician">
    <mat-autocomplete #autPhysician="matAutocomplete" [displayWith]="filterCompletePhysicians.displayFn">
      <mat-option *ngFor="let physician of filteredPhysiciansOptions | async" [value]="physician">
        {{physician.Name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <div class="full-width">
    <patient-autocomplete formControlName="Patient"></patient-autocomplete>
  </div>
  <mat-form-field class="medium-width">
    <input type="text" #equipment matInput placeholder="Equipo" formControlName="Equipment" [matAutocomplete]="autEquipment">
    <mat-autocomplete #autEquipment="matAutocomplete" [displayWith]="filterCompleteEquipments.displayFn">
      <mat-option *ngFor="let equipment of filteredEquipmentsOptions | async" [value]="equipment">
        {{equipment.Name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
    <input type="text" #doctor matInput placeholder="Servicio" formControlName="Service" [matAutocomplete]="autService">
    <mat-autocomplete #autService="matAutocomplete" [displayWith]="filterCompleteServices.displayFn">
      <mat-option *ngFor="let service of filteredServicesOptions | async" [value]="service">
        {{service.Name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
    <input type="text" #entity matInput placeholder="Entidad" (input)="onEntityChange()" formControlName="Entity" [matAutocomplete]="autEntity">
    <mat-autocomplete #autEntity="matAutocomplete" (optionSelected)="entitySelected($event.option.value)" [displayWith]="filterCompleteEntities.displayFn">
      <mat-option *ngFor="let entity of filteredEntitiesOptions | async" [value]="entity">
        {{entity.Name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
    <input type="text" #plan matInput placeholder="Plan" formControlName="Plan" [matAutocomplete]="autPlan">
    <mat-autocomplete #autPlan="matAutocomplete" [displayWith]="filterCompletePlan.displayFn">
      <mat-option *ngFor="let plan of filteredPlanOptions | async" [value]="plan">
        {{plan.Name}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
</form>
